import { Button, Card, Col, Flex, Form, Input, Row, Select, SelectProps, Space } from "antd";
import { useMutation, useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { RuleObject } from "antd/es/form";
import _ from "lodash";
import { Fragment, useState } from "react";
import { enmPasswordResetType } from "../../models/enums/PasswordResetType";
import { AuthService } from "../../services/AuthService";
import { toast } from "react-toastify";
import { mdlForgotPasswordRequest } from "../../models/service-models/auth/ForgotPasswordRequest";


export type ForgotPasswordProps = {
    callback?: Function;
    onClose?: Function;
}

const ForgotPasswordModal = (props: ForgotPasswordProps) => {
    const { t } = useTranslation();
    const [request, setRequest] = useState<mdlForgotPasswordRequest>({ type: enmPasswordResetType.Email });
    const [form] = Form.useForm();

    const validateEmail = (_: RuleObject, value: string) => {
        if (value != null && value.length > 0) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                return Promise.reject(new Error(`${value} ${t("common.isNotAValidMailAddress")}`));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    const { mutateAsync, isLoading, data } = useMutation(
        (data: mdlForgotPasswordRequest) => {
            return AuthService.ForgotPassword(data)
        },
        {
            onMutate(variables) {
                //dispatch(toLoading());
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header.success && data.body?.isSuccessful) {
                    toast.success(data.body.message);
                    props.callback && props.callback();
                }
                else {
                    if (data.body && !data.body?.isSuccessful)
                        toast.error(data.body?.message);
                    else if (data.header.messages) {
                        toast.error(_.first(data.header.messages)?.message);
                    }
                }
            },
        }
    );



    return (
        <Card loading={isLoading}>
            <Form
                form={form}
                name="send-action-mail-form"
                initialValues={{ type: enmPasswordResetType.Email }}
                layout="vertical"
                onFinish={async (values) => await mutateAsync(values)}
                autoComplete="off"
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item<mdlForgotPasswordRequest>
                            label={t("auth.reset.type")}
                            name={'type'}
                            rules={[
                                { required: true, message: t("common.required") },
                            ]}
                        >
                            <Select
                                onChange={(value: enmPasswordResetType) => { form.setFieldValue("value", ""); setRequest({ ...request, ["type"]: value }); }}
                                value={request.type}
                                options={[
                                    { value: enmPasswordResetType.Email, label: t("auth.reset.typeMail") },
                                    { value: enmPasswordResetType.UserName, label: t("auth.reset.typeUsername") },
                                    { value: enmPasswordResetType.Unknown, label: t("auth.reset.typeNone") },
                                ]}
                            />
                        </Form.Item>
                    </Col>

                    {
                        request && request.type == enmPasswordResetType.Email
                        &&
                        <Col span={24}>
                            <Form.Item<mdlForgotPasswordRequest>
                                label={t("auth.reset.mail")}
                                name={'value'}
                                rules={[
                                    { required: true, message: t("common.required") },
                                    {
                                        validator: validateEmail,
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                    }

                    {
                        request && request.type == enmPasswordResetType.UserName
                        &&
                        <Col span={24}>
                            <Form.Item<mdlForgotPasswordRequest>
                                label={t("auth.reset.username")}
                                name={'value'}
                                rules={[
                                    { required: true, message: t("common.required") }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                    }

                    {
                        request && request.type == enmPasswordResetType.Unknown
                        &&
                        <Fragment>
                            <Col span={24}>
                                <Form.Item<mdlForgotPasswordRequest>
                                    label={t("auth.reset.hotelName")}
                                    name={'hotelName'}
                                    rules={[
                                        { required: true, message: t("common.required") }
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item<mdlForgotPasswordRequest>
                                    label={t("auth.reset.fullName")}
                                    name={'nameSurname'}
                                    rules={[
                                        { required: true, message: t("common.required") }
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item<mdlForgotPasswordRequest>
                                    label={t("auth.reset.phone")}
                                    name={'phoneNumber'}
                                    rules={[
                                        { required: true, message: t("common.required") }
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Fragment>

                    }
                </Row>
                <Row style={{ marginTop: "25px" }} justify={"end"}>
                    <Form.Item>
                        <Flex align={"center"} justify="flex-end">
                            <Space>
                                <Button type="primary" htmlType="submit">{t("common.reset")}</Button>
                                <Button type="primary" onClick={() => props.onClose && props.onClose()} danger htmlType="button">{t("common.close")}</Button>
                            </Space>
                        </Flex>

                    </Form.Item>
                </Row>
            </Form>
        </Card>
    )
}

export default ForgotPasswordModal;